import { useState, useRef, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import * as XLSX from 'xlsx'
import { Upload, Check, ChevronDown, ChevronUp, Save, FolderOpen, Trash2, RefreshCw, Zap } from 'lucide-react'

function extraireCP(adresse) {
  if (!adresse) return ''
  const s = String(adresse).trim()
  if (/^\d{5}$/.test(s)) return s
  const match = s.match(/\b(\d{5})\b/)
  if (match) return match[1]
  return ''
}

function calculerAge(dob) {
  if (!dob) return null
  const today = new Date()
  const birth = new Date(dob)
  if (isNaN(birth)) return null
  let age = today.getFullYear() - birth.getFullYear()
  const m = today.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
  return age
}

function parseDate(val) {
  if (!val) return null
  if (val instanceof Date) return val.toISOString().split('T')[0]
  if (typeof val === 'number' && val > 1000) {
    const d = new Date(Math.round((val - 25569) * 86400 * 1000))
    return d.toISOString().split('T')[0]
  }
  const s = String(val).trim()
  // yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10)
  // dd/mm/yyyy (européen)
  const dmY4 = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)
  if (dmY4) return dmY4[3] + '-' + dmY4[2].padStart(2,'0') + '-' + dmY4[1].padStart(2,'0')
  // m/d/yy ou m/d/yyyy (américain xlsx) — ex: "5/11/73", "9/14/65", "7/5/25 18:39"
  const mdY = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})/)
  if (mdY) {
    let y = parseInt(mdY[3])
    if (y < 100) y = y <= 30 ? 2000 + y : 1900 + y
    return y + '-' + mdY[1].padStart(2,'0') + '-' + mdY[2].padStart(2,'0')
  }
  return null
}

function normaliserGenre(val) {
  if (!val) return ''
  const s = String(val).trim().toLowerCase()
  if (['m','h','homme','masculin','male'].includes(s)) return 'Masculin'
  if (['f','femme','feminin','féminin','female'].includes(s)) return 'Feminin'
  return val
}

function normaliserTypeVTT(val) {
  if (!val) return ''
  const s = String(val).trim().toUpperCase()
  if (s.includes('VTTAE')||s.includes('VAE')||s.includes('ELECTRIQUE')||s.includes('ÉLECTRIQUE')) return 'VTTAE'
  if (s.includes('VTT')) return 'VTT'
  return val
}

function sauvegarderModele(nom, data) {
  const m = JSON.parse(localStorage.getItem('importModeles')||'{}')
  m[nom] = data
  localStorage.setItem('importModeles', JSON.stringify(m))
}
function chargerModeles() { return JSON.parse(localStorage.getItem('importModeles')||'{}') }
function supprimerModele(nom) {
  const m = JSON.parse(localStorage.getItem('importModeles')||'{}')
  delete m[nom]
  localStorage.setItem('importModeles', JSON.stringify(m))
}

export default function Import({ courses }) {
  const [onglet, setOnglet] = useState('coureurs')

  // Import coureurs
  const [fichierCoureurs, setFichierCoureurs] = useState(null)
  const [colonnes, setColonnes] = useState([])
  const [lignes, setLignes] = useState([])
  const [mapping, setMapping] = useState({})
  const [equivalencesCourse, setEquivalencesCourse] = useState([])
  const [ignorerAnnules, setIgnorerAnnules] = useState(true)
  const [valeurAnnule, setValeurAnnule] = useState('Annulé')
  const [apercu, setApercu] = useState(null)
  const [importing, setImporting] = useState(false)
  const [resultat, setResultat] = useState(null)
  const [showConfig, setShowConfig] = useState(true)
  const [nomModele, setNomModele] = useState('')
  const [modeles, setModeles] = useState(chargerModeles())
  const [showModeles, setShowModeles] = useState(false)
  const [modeHelloAsso, setModeHelloAsso] = useState(false)
  const [colRepasOption, setColRepasOption] = useState("")
  const [colMontantRepas, setColMontantRepas] = useState("")
  const [tarifsRepas, setTarifsRepas] = useState([])
  const [repasNonRattachables, setRepasNonRattachables] = useState([])
  const [courseRepasId, setCourseRepasId] = useState('')   // id de la course Repas/Foodtruck en base

  // Import dossards
  const [fichierDossards, setFichierDossards] = useState(null)
  const [lignesDossards, setLignesDossards] = useState([])
  const [colonneDossard, setColonneDossard] = useState('')
  const [colonneCourse, setColonneCourse] = useState('')
  const [colonnesDossards, setColonnesDossards] = useState([])
  const [equivalencesCourseD, setEquivalencesCourseD] = useState([])
  const [apercuDossards, setApercuDossards] = useState(null)
  const [importingDossards, setImportingDossards] = useState(false)
  const [resultatDossards, setResultatDossards] = useState(null)

  // Gestion dossards
  const [dossardsDB, setDossardsDB] = useState([])
  const [coureurs, setCoureurs] = useState([])
  const [loadingDossards, setLoadingDossards] = useState(false)
  const [filterCourseD, setFilterCourseD] = useState('')
  const [filterStatutD, setFilterStatutD] = useState('')
  const [controleResultat, setControleResultat] = useState(null)
  const [attributionResultat, setAttributionResultat] = useState(null)
  const [loadingAttrib, setLoadingAttrib] = useState(false)
  const [syncResultat, setSyncResultat] = useState(null)
  const [loadingSync, setLoadingSync] = useState(false)
  const [editDossardId, setEditDossardId] = useState(null)
  const [editDossardCourse, setEditDossardCourse] = useState('')
  const [ajoutManuel, setAjoutManuel] = useState({ dossard: '', course_id: '' })
  const [ajoutManuelError, setAjoutManuelError] = useState('')
  const [confirmVider, setConfirmVider] = useState(false)
  const [loadingVider, setLoadingVider] = useState(false)

  const fileRef = useRef()
  const fileDRef = useRef()

  const CHAMPS = [
    { key: 'nom', label: 'Nom *' },
    { key: 'prenom', label: 'Prenom *' },
    { key: 'email', label: 'Email' },
    { key: 'telephone', label: 'Telephone' },
    { key: 'dob', label: 'Date naissance' },
    { key: 'genre', label: 'Genre' },
    { key: 'type_vtt', label: 'Type VTT' },
    { key: 'course_src', label: 'Course *' },
    { key: 'cp', label: 'Code postal / Adresse' },
    { key: 'prix_paye', label: 'Prix paye' },
    { key: 'paye_par', label: 'Paye par' },
    { key: 'nb_repas', label: 'Nb repas' },
    { key: 'dossard', label: 'Dossard (optionnel)' },
    { key: 'statut_commande', label: 'Statut commande (filtrer annules)' },
    { key: 'date_commande', label: 'Date de commande' },
    { key: 'helloasso_ref_commande', label: 'Ref commande HelloAsso' },
    { key: 'helloasso_num_billet', label: 'Num billet HelloAsso (cle MAJ)' },
  ]

  async function fetchDossardsEtCoureurs() {
    setLoadingDossards(true)
    const [d, c] = await Promise.all([
      supabase.from('dossards_disponibles').select('*, courses(nom)').order('dossard'),
      supabase.from('coureurs').select('id, nom, prenom, dossard, course_id, courses(nom)').order('nom'),
    ])
    const dossards = d.data || []
    const coureursData = c.data || []
    setDossardsDB(dossards)
    setCoureurs(coureursData)
    setLoadingDossards(false)
    return { dossards, coureursData }
  }

  useEffect(() => {
    if (onglet === 'gestion') fetchDossardsEtCoureurs()
  }, [onglet])

  function lireFichier(file, callback) {
    const reader = new FileReader()
    reader.onload = e => {
      const data = new Uint8Array(e.target.result)
      const wb = XLSX.read(data, { type: 'array', cellDates: true })
      const ws = wb.Sheets[wb.SheetNames[0]]
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'yyyy-mm-dd' })
      callback(rows)
    }
    reader.readAsArrayBuffer(file)
  }

  function onFichierCoureurs(file) {
    setFichierCoureurs(file); setApercu(null); setResultat(null)
    lireFichier(file, rows => {
      if (rows.length < 2) return
      const headers = rows[0].map((h, i) => ({ index: i, label: String(h || 'Col '+(i+1)) }))
      setColonnes(headers)
      setLignes(rows.slice(1).filter(r => r.some(c => c !== null && c !== undefined && c !== '')))
      const autoMap = {}
      headers.forEach(h => {
        const l = h.label.toLowerCase()
        if (l.includes('nom participant')||l==='nom') autoMap['nom'] = String(h.index)
        else if (l.includes('prenom participant')||l.includes('prénom participant')||l==='prenom'||l==='prénom') autoMap['prenom'] = String(h.index)
        else if (l.includes('email')) autoMap['email'] = String(h.index)
        else if (l.includes('telephone')||l.includes('téléphone')||l.includes('tél')) autoMap['telephone'] = String(h.index)
        else if (l.includes('naissance')) autoMap['dob'] = String(h.index)
        else if (l.includes('sexe')||l==='genre') autoMap['genre'] = String(h.index)
        else if (l.includes('type de velo')||l.includes('type de vélo')||l.includes('vélo')) autoMap['type_vtt'] = String(h.index)
        else if ((l.includes('tarif')||l.includes('parcours')||l.includes('formule'))&&!l.includes('montant')) autoMap['course_src'] = String(h.index)
        else if (l.includes('adresse')||l.includes('postal')||l==='cp') autoMap['cp'] = String(h.index)
        else if (l.includes('montant tarif')||l.includes('prix')) autoMap['prix_paye'] = String(h.index)
        else if (l.includes('statut')) autoMap['statut_commande'] = String(h.index)
        else if (l==='nom payeur'||l.includes('nom payeur')) autoMap['paye_par'] = String(h.index)
        else if (l.includes('date commande')||l.includes('date de commande')||l.includes('date_commande')||l==='date') autoMap['date_commande'] = String(h.index)
        else if (l.includes('repas')&&!l.includes('montant')) autoMap['nb_repas'] = String(h.index)
        else if (l==='référence commande'||l==='reference commande') autoMap['helloasso_ref_commande'] = String(h.index)
        else if (l==='numéro de billet'||l==='numero de billet'||l==='num billet') autoMap['helloasso_num_billet'] = String(h.index)
      })
      // Detection auto mode HelloAsso
      let autoColRepasOption = '', autoColMontantRepas = ''
      headers.forEach(h => {
        const l = h.label.toLowerCase()
        if (l.includes('repas') && !l.includes('montant')) autoColRepasOption = String(h.index)
        if (l.includes('montant') && l.includes('repas')) autoColMontantRepas = String(h.index)
      })
      const hasHelloAssoShape = !!autoMap['statut_commande'] && headers.some(h => {
        const l = h.label.toLowerCase()
        return l.includes('rence commande')
      })
      if (hasHelloAssoShape) {
        setModeHelloAsso(true)
        setColRepasOption(autoColRepasOption)
        setColMontantRepas(autoColMontantRepas)
      }
      setMapping(autoMap)
      const idxCourse = headers.find(h => {
        const l = h.label.toLowerCase()
        return (l.includes('tarif')||l.includes('parcours')||l.includes('formule'))&&!l.includes('montant')
      })
      if (idxCourse) {
        const vals = [...new Set(rows.slice(1).map(r => r[idxCourse.index]).filter(Boolean))]
        setEquivalencesCourse(vals.map(v => ({ source: String(v), cible: '' })))
        const repasLike = vals.filter(v => String(v).toLowerCase().includes('repas') || String(v).toLowerCase().includes('food truck') || String(v).toLowerCase().includes('foodtruck'))
        setTarifsRepas(repasLike.map(v => String(v)))
      }
    })
  }

  function appliquerModele(modele) {
    setMapping(modele.mapping || {})
    setIgnorerAnnules(modele.ignorerAnnules ?? true)
    setValeurAnnule(modele.valeurAnnule || 'Annulé')
    if (modele.equivalencesCourse) {
      setEquivalencesCourse(prev => prev.map(eq => {
        const saved = modele.equivalencesCourse.find(e => e.source === eq.source)
        return saved ? { ...eq, cible: saved.cible } : eq
      }))
    }
    setShowModeles(false)
  }

  function enregistrerModele() {
    if (!nomModele.trim()) return
    sauvegarderModele(nomModele.trim(), { mapping, ignorerAnnules, valeurAnnule, equivalencesCourse })
    setModeles(chargerModeles())
    setNomModele('')
  }

  function supprimerModeleLocal(nom) {
    supprimerModele(nom)
    setModeles(chargerModeles())
  }

  function resoudreEquivalenceCourse(valeur, equivalences) {
    if (!valeur) return null
    const eq = equivalences.find(e => e.source === String(valeur) && e.cible)
    if (eq) return eq.cible
    const direct = courses.find(c => c.nom.toLowerCase() === String(valeur).toLowerCase())
    if (direct) return direct.id
    return null
  }

  function norm(s) { return String(s||'').trim().toLowerCase() }

  // Mode HelloAsso : pré-traitement des lignes brutes
  // - Fusionne les repas (option + tarif séparé) sur chaque coureur (clé nom+prenom)
  // - Retourne { lignesCoureurs, repasNonRattaches }
  function preprocessHelloAsso(lignesBrutes) {
    const idxTarif = mapping.course_src ? parseInt(mapping.course_src) : -1
    const idxNom = mapping.nom ? parseInt(mapping.nom) : -1
    const idxPrenom = mapping.prenom ? parseInt(mapping.prenom) : -1
    const idxRepasOpt = colRepasOption !== '' ? parseInt(colRepasOption) : -1
    const idxPrix = mapping.prix_paye ? parseInt(mapping.prix_paye) : -1

    const PRIX_REPAS_UNITAIRE = 13 // valeur par défaut, ajustable

    // Séparer lignes courses / lignes repas-séparées
    const lignesCourses = []
    const lignesRepasSepare = []

    for (const l of lignesBrutes) {
      const tarif = String(l[idxTarif]||'').trim()
      if (tarifsRepas.some(t => t.trim().toLowerCase() === tarif.toLowerCase())) {
        lignesRepasSepare.push(l)
      } else {
        lignesCourses.push(l)
      }
    }

    // Construire map nom+prenom → nb_repas cumulé depuis lignes-courses (option)
    const repasParCoureur = {}
    for (const l of lignesCourses) {
      const k = norm(l[idxNom]) + '|' + norm(l[idxPrenom])
      if (idxRepasOpt >= 0 && l[idxRepasOpt] && String(l[idxRepasOpt]).trim().toLowerCase() === 'oui') {
        repasParCoureur[k] = (repasParCoureur[k] || 0) + 1
      }
    }

    // Ajouter les repas des lignes séparées par nom participant
    const repasNonRattaches = []
    for (const l of lignesRepasSepare) {
      const k = norm(l[idxNom]) + '|' + norm(l[idxPrenom])
      const montant = idxPrix >= 0 ? parseFloat(String(l[idxPrix]||'').replace(',','.')) || 0 : 0
      const qte = montant > 0 ? Math.round(montant / PRIX_REPAS_UNITAIRE) : 1
      const isCoureur = lignesCourses.some(lc => norm(lc[idxNom]) + '|' + norm(lc[idxPrenom]) === k)
      if (norm(l[idxNom]).includes('destas')) console.log('DESTAS k=', k, 'isCoureur=', isCoureur, 'destas dans courses=', lignesCourses.filter(lc=>norm(lc[idxNom]).includes('destas')).map(lc=>norm(lc[idxNom])+'|'+norm(lc[idxPrenom])))
      if (isCoureur) {
        repasParCoureur[k] = (repasParCoureur[k] || 0) + qte
      } else {
        repasNonRattaches.push({ nom: String(l[idxNom]||''), prenom: String(l[idxPrenom]||''), qte })
      }
    }
    return { lignesCoureurs: lignesCourses, repasParCoureur, repasNonRattaches }
  }

  async function genererApercu() {
    if (!mapping.nom || !mapping.prenom || !mapping.course_src) return
    const { data: existants } = await supabase.from('coureurs').select('id, nom, prenom, course_id, dossard, email, paye, helloasso_num_billet')
    const aCreer = [], aMettre = [], ignores = [], doublonsInterne = []
    const vus = new Set()

    // Pré-traitement HelloAsso si mode activé
    let lignesATraiter = lignes
    let repasParCoureur = {}
    let repasNonRatt = []
    let crId = courseRepasId
    if (modeHelloAsso) {
      const pre = preprocessHelloAsso(lignes)
      lignesATraiter = pre.lignesCoureurs
      repasParCoureur = pre.repasParCoureur
      repasNonRatt = pre.repasNonRattaches
      setRepasNonRattachables(repasNonRatt)
      // Charger l'id de la course Repas si nécessaire
      if (repasNonRatt.length > 0 && !crId) crId = await fetchCourseRepas()
    }

    const aAnnuler = [] // coureurs déjà en base dont le statut passe à annulé
    const repasAttribue = new Set() // évite de doubler les repas sur multi-courses

    for (const ligne of lignesATraiter) {
      const statut_cmd = mapping.statut_commande ? ligne[parseInt(mapping.statut_commande)] : null
      const estAnnule = statut_cmd ? String(statut_cmd).trim() === valeurAnnule : false

      const nom = String(ligne[parseInt(mapping.nom)]||'').trim()
      const prenom = String(ligne[parseInt(mapping.prenom)]||'').trim()
      if (!nom||!prenom) { ignores.push({ raison: 'Nom/prenom vide', ligne }); continue }

      const valCourse = mapping.course_src ? ligne[parseInt(mapping.course_src)] : null
      const courseId = resoudreEquivalenceCourse(valCourse, equivalencesCourse)
      if (!courseId) { ignores.push({ raison: 'Course non mappee : ' + valCourse, ligne }); continue }

      const cleNomPrenom = (nom+'|'+prenom).toLowerCase()

      // Chercher si ce coureur existe déjà en base
      const email = mapping.email ? String(ligne[parseInt(mapping.email)]||'').trim() : ''
      const numBillet = mapping.helloasso_num_billet ? String(ligne[parseInt(mapping.helloasso_num_billet)]||'').trim() : ''
      const existant = existants?.find(e => numBillet && e.helloasso_num_billet === numBillet)
        || existants?.find(e => e.nom?.toLowerCase()===nom.toLowerCase() && e.prenom?.toLowerCase()===prenom.toLowerCase() && e.course_id === courseId)

      if (estAnnule) {
        // Coureur déjà en base → le marquer à annuler (paye=false)
        if (existant) aAnnuler.push({ id: existant.id, nom, prenom, courseNom: courses.find(c=>c.id===existant.course_id)?.nom })
        else ignores.push({ raison: 'Annule (non en base)', ligne })
        continue
      }

      // Ligne valide non-annulée
      if (ignorerAnnules && estAnnule) { ignores.push({ raison: 'Annule', ligne }); continue }

      const dob = mapping.dob ? parseDate(ligne[parseInt(mapping.dob)]) : null
      const genre = mapping.genre ? normaliserGenre(ligne[parseInt(mapping.genre)]) : ''
      const type_vtt = mapping.type_vtt ? normaliserTypeVTT(ligne[parseInt(mapping.type_vtt)]) : ''
      const cp = extraireCP(mapping.cp ? String(ligne[parseInt(mapping.cp)]||'') : '')
      const telephone = mapping.telephone ? String(ligne[parseInt(mapping.telephone)]||'').trim() : ''
      const prix_paye = mapping.prix_paye ? parseFloat(String(ligne[parseInt(mapping.prix_paye)]||'').replace(',','.')) || null : null
      const dossard = mapping.dossard ? String(ligne[parseInt(mapping.dossard)]||'').trim() || null : null
      const paye = statut_cmd ? !estAnnule : false
      const date_commande = mapping.date_commande ? parseDate(ligne[parseInt(mapping.date_commande)]) : null
      const paye_par = mapping.paye_par ? String(ligne[parseInt(mapping.paye_par)]||'').trim() || null : null
      const helloasso_ref_commande = mapping.helloasso_ref_commande ? String(ligne[parseInt(mapping.helloasso_ref_commande)]||'').trim() || null : null
      const helloasso_num_billet = mapping.helloasso_num_billet ? String(ligne[parseInt(mapping.helloasso_num_billet)]||'').trim() || null : null

      // Détection homonyme : même nom + prénom + dob + course dans le fichier
      const cleDoublon = (nom+'|'+prenom+'|'+(dob||'')+'|'+(courseId||'')).toLowerCase()
      if (vus.has(cleDoublon)) {
        doublonsInterne.push({ nom, prenom, dob, courseNom: courses.find(c=>c.id===courseId)?.nom })
        continue
      }
      vus.add(cleDoublon)

      // Pour les repas séparés sur coureur multi-courses : affecter à la première course seulement
      let nb_repas_val = 0
      if (modeHelloAsso) {
        if (repasParCoureur[cleNomPrenom] && !repasAttribue.has(cleNomPrenom)) {
          nb_repas_val = repasParCoureur[cleNomPrenom]
          repasAttribue.add(cleNomPrenom)
        }
      } else {
        nb_repas_val = mapping.nb_repas ? (ligne[parseInt(mapping.nb_repas)] && String(ligne[parseInt(mapping.nb_repas)]).trim() !== '' ? 1 : 0) : 0
      }

      const coureurData = { nom, prenom, email, telephone, dob, age: calculerAge(dob), genre, type_vtt, cp, prix_paye, nb_repas: nb_repas_val, dossard, course_id: courseId, paye, date_commande, helloasso_ref_commande, helloasso_num_billet, paye_par }

      if (existant) {
        const diffs = []
        if (existant.course_id !== courseId) diffs.push('course')
        if (email && existant.email !== email) diffs.push('email')
        if (existant.paye !== paye) diffs.push(paye ? 'paye ✓' : 'annulé ✗')
        aMettre.push({ ...coureurData, id: existant.id, diffs, existant })
      } else { aCreer.push(coureurData) }
    }

    // Ajouter les proches non-inscrits comme coureurs dans la course Repas/Foodtruck
    if (modeHelloAsso && repasNonRatt.length > 0) {
      for (const r of repasNonRatt) {
        if (!r.nom && !r.prenom) continue
        const nomP = String(r.nom || '').trim()
        const prenomP = String(r.prenom || '').trim() || '—'
        const existant = existants?.find(e =>
          e.nom?.toLowerCase()===nomP.toLowerCase() && e.prenom?.toLowerCase()===prenomP.toLowerCase()
        )
        const coureurRepas = {
          nom: nomP, prenom: prenomP, email: '', telephone: '', dob: null, age: null,
          genre: '', type_vtt: '', cp: '', prix_paye: null,
          nb_repas: r.qte, dossard: null, course_id: crId, paye: true, date_commande: r.date_commande || null
        }
        if (existant) {
          const diffs = ['repas=' + r.qte]
          if (existant.course_id !== crId) diffs.push('course→Repas')
          aMettre.push({ ...coureurRepas, id: existant.id, diffs, existant })
        } else {
          // Ne pas utiliser vus ici : un proche peut avoir le même nom qu'un coureur
          // mais être dans une course différente (Repas/Foodtruck)
          const cleRepas = (nomP+'|'+prenomP).toLowerCase() + '|repas'
          if (!vus.has(cleRepas)) { vus.add(cleRepas); aCreer.push(coureurRepas) }
        }
      }
    }
    setApercu({ aCreer, aMettre, ignores, doublonsInterne, aAnnuler })
  }

  async function lancerImport() {
    if (!apercu) return
    setImporting(true)
    let crees = 0, majRes = 0, annules = 0, erreurs = 0

    // Charger liste dossards actuelle pour vérif unicité
    const { data: dossardsActuels } = await supabase.from('dossards_disponibles').select('dossard, id, attribue, coureur_id')

    for (const c of apercu.aCreer) {
      const { data: inserted, error } = await supabase.from('coureurs').insert(c).select().single()
      if (!error && inserted) {
        crees++
        if (c.dossard) await _syncDossardImport(c.dossard, c.course_id, inserted.id, dossardsActuels)
      } else { console.error(error); erreurs++ }
    }
    for (const c of apercu.aMettre) {
      const { id, diffs, existant, ...data } = c
      const { error } = await supabase.from('coureurs').update(data).eq('id', id)
      if (!error) {
        majRes++
        if (data.dossard) await _syncDossardImport(data.dossard, data.course_id, id, dossardsActuels)
      } else { console.error(error); erreurs++ }
    }
    for (const c of (apercu.aAnnuler || [])) {
      const { error } = await supabase.from('coureurs').update({ paye: false }).eq('id', c.id)
      if (!error) annules++; else { console.error(error); erreurs++ }
    }
    setResultat({ crees, majRes, annules, erreurs, ignores: apercu.ignores.length })
    setApercu(null)
    setImporting(false)
  }

  async function _syncDossardImport(dossard, courseId, coureurId, dossardsActuels) {
    const existant = dossardsActuels?.find(d => d.dossard === dossard)
    if (existant) {
      if (!existant.attribue || existant.coureur_id !== coureurId) {
        await supabase.from('dossards_disponibles').update({ attribue: true, coureur_id: coureurId }).eq('id', existant.id)
      }
    } else {
      // Dossard absent → l'ajouter (unicité globale garantie car on vient de vérifier)
      await supabase.from('dossards_disponibles').insert({ dossard, course_id: courseId, attribue: true, coureur_id: coureurId })
      dossardsActuels?.push({ dossard, attribue: true, coureur_id: coureurId })
    }
  }

  // Charger l'id de la course Repas/Foodtruck une seule fois au besoin
  async function fetchCourseRepas() {
    if (courseRepasId) return courseRepasId
    const { data } = await supabase.from('courses').select('id').eq('is_repas_only', true).maybeSingle()
    if (data?.id) { setCourseRepasId(data.id); return data.id }
    return null
  }

  function onFichierDossards(file) {
    setFichierDossards(file); setApercuDossards(null); setResultatDossards(null)
    lireFichier(file, rows => {
      if (rows.length < 2) return
      const headers = rows[0].map((h, i) => ({ index: i, label: String(h || 'Col '+(i+1)) }))
      setColonnesDossards(headers)
      setLignesDossards(rows.slice(1).filter(r => r.some(c => c)))
      headers.forEach(h => {
        const l = h.label.toLowerCase()
        if (l.includes('dossard')) setColonneDossard(String(h.index))
        if (l.includes('course')||l.includes('parcours')) setColonneCourse(String(h.index))
      })
      const idxC = headers.findIndex(h => h.label.toLowerCase().includes('course')||h.label.toLowerCase().includes('parcours'))
      if (idxC >= 0) {
        const vals = [...new Set(rows.slice(1).map(r => r[idxC]).filter(Boolean))]
        setEquivalencesCourseD(vals.map(v => ({ source: String(v), cible: '' })))
      }
    })
  }

  async function genererApercuDossards() {
    if (!colonneDossard) return
    const { data: existants } = await supabase.from('dossards_disponibles').select('dossard, course_id, attribue')
    const aAjouter = [], dejaPresents = [], sansCorrespondance = []
    for (const ligne of lignesDossards) {
      const dossard = String(ligne[parseInt(colonneDossard)]||'').trim()
      if (!dossard) continue
      const valCourse = colonneCourse ? ligne[parseInt(colonneCourse)] : null
      const courseId = valCourse ? resoudreEquivalenceCourse(valCourse, equivalencesCourseD) : null
      if (!courseId && colonneCourse) { sansCorrespondance.push(dossard); continue }
      const existant = existants?.find(e => e.dossard === dossard)
      if (existant) { dejaPresents.push({ dossard, attribue: existant.attribue }); continue }
      aAjouter.push({ dossard, course_id: courseId })
    }
    setApercuDossards({ aAjouter, dejaPresents, sansCorrespondance })
  }

  async function lancerImportDossards() {
    if (!apercuDossards) return
    setImportingDossards(true)
    let ajoutes = 0, erreurs = 0
    for (const d of apercuDossards.aAjouter) {
      const { error } = await supabase.from('dossards_disponibles').insert(d)
      if (!error) ajoutes++; else erreurs++
    }
    setResultatDossards({ ajoutes, erreurs, dejaPresents: apercuDossards.dejaPresents.length })
    setApercuDossards(null)
    setImportingDossards(false)
    // Synchroniser automatiquement apres import
    await fetchDossardsEtCoureurs()
    await syncDossardsCoureurs(true)
  }

  async function ajouterDossardManuel() {
    const code = ajoutManuel.dossard.trim()
    if (!code) { setAjoutManuelError('Code dossard requis'); return }
    // Unicité globale
    const existant = dossardsDB.find(d => d.dossard === code)
    if (existant) { setAjoutManuelError(`Dossard "${code}" déjà présent dans la liste`); return }
    const { error } = await supabase.from('dossards_disponibles').insert({ dossard: code, course_id: ajoutManuel.course_id || null, attribue: false })
    if (error) { setAjoutManuelError('Erreur : ' + error.message); return }
    setAjoutManuel({ dossard: '', course_id: '' })
    setAjoutManuelError('')
    await fetchDossardsEtCoureurs()
  }

  async function viderDossards() {
    setLoadingVider(true)
    // Retirer dossard de tous les coureurs
    await supabase.from('coureurs').update({ dossard: null }).neq('dossard', null)
    // Supprimer toute la liste
    await supabase.from('dossards_disponibles').delete().neq('id', '00000000-0000-0000-0000-000000000000')
    setConfirmVider(false)
    setLoadingVider(false)
    await fetchDossardsEtCoureurs()
  }

  async function changerCourseDossard(dossardEntry, newCourseId) {
    if (!newCourseId || newCourseId === dossardEntry.course_id) { setEditDossardId(null); return }
    await supabase.from('dossards_disponibles').update({ course_id: newCourseId }).eq('id', dossardEntry.id)
    setEditDossardId(null)
    await fetchDossardsEtCoureurs()
  }

  // Synchronisation dossards <-> coureurs
  // Pour chaque coureur avec un dossard, verifier que dossards_disponibles est a jour
  // Pour chaque dossard marque attribue sans coureur valide, le liberer
  async function syncDossardsCoureurs(silent = false) {
    setLoadingSync(true)
    const { data: tousLesDossards } = await supabase.from('dossards_disponibles').select('*')
    const { data: tousLesCoureurs } = await supabase.from('coureurs').select('id, nom, prenom, dossard, course_id')

    let syncs = 0, liberations = 0

    // 1. Coureurs avec dossard -> marquer attribue dans dossards_disponibles
    for (const coureur of tousLesCoureurs || []) {
      if (!coureur.dossard) continue
      const dossardEntry = tousLesDossards?.find(d => d.dossard === coureur.dossard && d.course_id === coureur.course_id)
      if (!dossardEntry) continue // hors liste, on ignore
      if (!dossardEntry.attribue || dossardEntry.coureur_id !== coureur.id) {
        await supabase.from('dossards_disponibles')
          .update({ attribue: true, coureur_id: coureur.id })
          .eq('id', dossardEntry.id)
        syncs++
      }
    }

    // 2. Dossards marques attribue mais coureur_id ne correspond plus ou coureur n'a plus ce dossard
    for (const d of tousLesDossards || []) {
      if (!d.attribue) continue
      const coureur = tousLesCoureurs?.find(c => c.id === d.coureur_id)
      if (!coureur || coureur.dossard !== d.dossard) {
        await supabase.from('dossards_disponibles')
          .update({ attribue: false, coureur_id: null })
          .eq('id', d.id)
        liberations++
      }
    }

    await fetchDossardsEtCoureurs()
    setLoadingSync(false)
    if (!silent) setSyncResultat({ syncs, liberations })
  }

  // Controle coherence
  async function lancerControle() {
    const { dossards: fd, coureursData: fc } = await fetchDossardsEtCoureurs()
    const sansDossard = fc.filter(c => !c.dossard)
    const horsListe = fc.filter(c => c.dossard && !fd.find(d => d.dossard === c.dossard && d.course_id === c.course_id))
    const desynchro = fd.filter(d => {
      if (!d.attribue) return false
      const coureur = fc.find(c => c.id === d.coureur_id)
      return !coureur || coureur.dossard !== d.dossard
    })
    setControleResultat({ sansDossard, horsListe, desynchro })
  }

  // Attribution auto
  async function attribuerDossardsAuto() {
    setLoadingAttrib(true)

    // Fetch fraîches depuis Supabase (pas le state React, qui peut être stale)
    const [{ data: tousLesDossards }, { data: tousLesCoureurs }] = await Promise.all([
      supabase.from('dossards_disponibles').select('*'),
      supabase.from('coureurs').select('id, nom, prenom, dossard, course_id'),
    ])

    const sansDossard = (tousLesCoureurs || []).filter(c => !c.dossard)

    // Tri numérique (évite "10" < "9" en lexicographique)
    const extractNum = s => parseInt(String(s).replace(/\D.*/, '')) || 0
    const dossardsLibres = (tousLesDossards || [])
      .filter(d => !d.attribue)
      .sort((a, b) => extractNum(a.dossard) - extractNum(b.dossard) || String(a.dossard).localeCompare(String(b.dossard)))

    let attribues = 0, sansDisponible = 0

    for (const coureur of sansDossard) {
      // findIndex + splice : retire le dossard de la liste après attribution pour ne jamais le réutiliser
      const idx = dossardsLibres.findIndex(d => d.course_id === coureur.course_id)
      if (idx === -1) { sansDisponible++; continue }
      const dispo = dossardsLibres[idx]
      const [r1, r2] = await Promise.all([
        supabase.from('coureurs').update({ dossard: dispo.dossard }).eq('id', coureur.id),
        supabase.from('dossards_disponibles').update({ attribue: true, coureur_id: coureur.id }).eq('id', dispo.id),
      ])
      if (r1.error || r2.error) {
        console.error('Erreur attribution', dispo.dossard, coureur.id, r1.error, r2.error)
        sansDisponible++
        continue
      }
      dossardsLibres.splice(idx, 1)
      attribues++
    }

    setAttributionResultat({ attribues, sansDisponible })
    setLoadingAttrib(false)
    await fetchDossardsEtCoureurs()
    setControleResultat(null)
  }

  const dossardsFiltres = dossardsDB.filter(d => {
    if (filterCourseD && d.course_id !== filterCourseD) return false
    if (filterStatutD === 'libre' && d.attribue) return false
    if (filterStatutD === 'attribue' && !d.attribue) return false
    return true
  })

  const nbLibres = dossardsDB.filter(d => !d.attribue).length
  const nbAttribues = dossardsDB.filter(d => d.attribue).length

  return (
    <div className="admin">
      <h1>Import</h1>

      <div className="dash-onglets" style={{marginBottom:16}}>
        <button className={'dash-onglet '+(onglet==='coureurs'?'active':'')} onClick={() => setOnglet('coureurs')}>Import coureurs</button>
        <button className={'dash-onglet '+(onglet==='dossards'?'active':'')} onClick={() => setOnglet('dossards')}>Import dossards</button>
        <button className={'dash-onglet '+(onglet==='gestion'?'active':'')} onClick={() => setOnglet('gestion')}>Gestion dossards</button>
      </div>

      {/* ===================== IMPORT COUREURS ===================== */}
      {onglet === 'coureurs' && (
        <div>
          {Object.keys(modeles).length > 0 && (
            <div className="section">
              <div className="section-header" onClick={() => setShowModeles(!showModeles)}>
                <h2>Modeles sauvegardes ({Object.keys(modeles).length})</h2>
                {showModeles ? <ChevronUp size={18}/> : <ChevronDown size={18}/>}
              </div>
              {showModeles && (
                <div className="section-body">
                  <div style={{display:'flex', flexWrap:'wrap', gap:8}}>
                    {Object.entries(modeles).map(([nom, data]) => (
                      <div key={nom} style={{display:'flex', alignItems:'center', gap:6, background:'#f0faf6', border:'1px solid #b2d8cc', borderRadius:6, padding:'6px 12px'}}>
                        <span style={{fontSize:13, fontWeight:600}}>{nom}</span>
                        <button className="btn-small success" onClick={() => appliquerModele(data)}><FolderOpen size={12}/> Charger</button>
                        <button className="btn-small danger" onClick={() => supprimerModeleLocal(nom)}><Trash2 size={12}/></button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="section">
            <div className="section-body" style={{paddingTop:16}}>
              <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" style={{display:'none'}} onChange={e => e.target.files[0] && onFichierCoureurs(e.target.files[0])} />
              <button className="btn success" onClick={() => fileRef.current?.click()}>
                <Upload size={16}/> {fichierCoureurs ? fichierCoureurs.name : 'Choisir un fichier (CSV ou Excel)'}
              </button>
              {fichierCoureurs && <span style={{marginLeft:10, fontSize:13, color:'#888'}}>{lignes.length} lignes detectees</span>}
            </div>
          </div>

          {colonnes.length > 0 && (
            <>
              <div className="section">
                <div className="section-header" onClick={() => setShowConfig(!showConfig)}>
                  <h2>2. Mapping des colonnes</h2>
                  {showConfig ? <ChevronUp size={18}/> : <ChevronDown size={18}/>}
                </div>
                {showConfig && (
                  <div className="section-body">
                    <div className="mapping-grid">
                      {CHAMPS.map(champ => (
                        <div key={champ.key} className="mapping-row">
                          <label className="mapping-label">{champ.label}</label>
                          <select value={mapping[champ.key]||''} onChange={e => setMapping(prev => ({...prev, [champ.key]: e.target.value}))}>
                            <option value="">-- Ignorer --</option>
                            {colonnes.map(c => <option key={c.index} value={String(c.index)}>{c.label}</option>)}
                          </select>
                        </div>
                      ))}
                    </div>
                    <div style={{marginTop:16, padding:12, background:'#f9f9f9', borderRadius:8}}>
                      <div className="field-row">
                        <label style={{fontWeight:600}}>Mode HelloAsso</label>
                        <input type="checkbox" checked={modeHelloAsso} onChange={e => setModeHelloAsso(e.target.checked)} />
                        <span style={{fontSize:12, color:'#888', marginLeft:6}}>Fusion automatique repas option + tarif séparé</span>
                      </div>
                      {modeHelloAsso && (
                        <div style={{marginTop:10, padding:10, background:'#e8f5f0', borderRadius:6, display:'flex', gap:16, flexWrap:'wrap'}}>
                          <div className="field-row">
                            <label style={{fontSize:12}}>Colonne option repas (Oui/None)</label>
                            <select value={colRepasOption} onChange={e => setColRepasOption(e.target.value)} style={{fontSize:12}}>
                              <option value="">-- Ignorer --</option>
                              {colonnes.map(c => <option key={c.index} value={String(c.index)}>{c.label}</option>)}
                            </select>
                          </div>
                          <div className="field-row">
                            <label style={{fontSize:12}}>Colonne montant repas option</label>
                            <select value={colMontantRepas} onChange={e => setColMontantRepas(e.target.value)} style={{fontSize:12}}>
                              <option value="">-- Ignorer --</option>
                              {colonnes.map(c => <option key={c.index} value={String(c.index)}>{c.label}</option>)}
                            </select>
                          </div>
                        </div>
                      )}
                      <div className="field-row" style={{marginTop:10}}>
                        <label>Ignorer les annules</label>
                        <input type="checkbox" checked={ignorerAnnules} onChange={e => setIgnorerAnnules(e.target.checked)} />
                      </div>
                      {ignorerAnnules && (
                        <div className="field-row" style={{marginTop:8}}>
                          <label>Valeur annule</label>
                          <input value={valeurAnnule} onChange={e => setValeurAnnule(e.target.value)} style={{width:140}} />
                        </div>
                      )}
                    </div>
                    <div style={{marginTop:12, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                      <input placeholder="Nom du modele (ex: HelloAsso 2025)" value={nomModele} onChange={e => setNomModele(e.target.value)}
                        style={{padding:'6px 10px', border:'1px solid #ddd', borderRadius:6, fontSize:13, flex:1, minWidth:200}} />
                      <button className="btn" style={{background:'#f0f0f0', display:'flex', alignItems:'center', gap:6}} onClick={enregistrerModele} disabled={!nomModele.trim()}>
                        <Save size={14}/> Sauvegarder ce modele
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="section">
                <div className="section-header"><h2>3. Equivalences des courses</h2></div>
                <div className="section-body">
                  <p style={{fontSize:13, color:'#888', marginBottom:8}}>Les lignes avec "Non importe" seront exclues de l'import.</p>
                  {modeHelloAsso && tarifsRepas.length > 0 && (
                    <div style={{marginBottom:12, padding:'8px 12px', background:'#fff8e6', border:'1px solid #ffc107', borderRadius:6, fontSize:12, color:'#856404'}}>
                      ⚡ Mode HelloAsso — tarifs détectés comme "repas seul" (non importés comme coureur, repas fusionnés) :<br/>
                      <div style={{marginTop:4, display:'flex', gap:6, flexWrap:'wrap'}}>
                        {tarifsRepas.map(t => <span key={t} style={{background:'#ffc107', color:'#333', borderRadius:4, padding:'2px 8px', fontWeight:600}}>{t}</span>)}
                      </div>
                      <div style={{marginTop:6}}>
                        <label style={{marginRight:6}}>Ajouter un tarif repas :</label>
                        <select style={{fontSize:12}} onChange={e => { if(e.target.value && !tarifsRepas.includes(e.target.value)) setTarifsRepas(prev=>[...prev, e.target.value]); e.target.value='' }}>
                          <option value="">--</option>
                          {equivalencesCourse.filter(eq => !tarifsRepas.includes(eq.source)).map(eq => <option key={eq.source} value={eq.source}>{eq.source}</option>)}
                        </select>
                        {tarifsRepas.map(t => (
                          <button key={t} onClick={() => setTarifsRepas(prev => prev.filter(x => x !== t))} style={{marginLeft:4, fontSize:11, background:'#fee', border:'1px solid #fcc', borderRadius:4, padding:'1px 6px', cursor:'pointer'}}>✕ {t}</button>
                        ))}
                      </div>
                    </div>
                  )}
                  <table className="table">
                    <thead><tr><th>Valeur dans le fichier</th><th>Course dans l'application</th></tr></thead>
                    <tbody>
                      {equivalencesCourse.map((eq, i) => (
                        <tr key={i}>
                          <td><strong>{eq.source}</strong></td>
                          <td>
                            <select value={eq.cible} onChange={e => { const copy=[...equivalencesCourse]; copy[i]={...copy[i],cible:e.target.value}; setEquivalencesCourse(copy) }}>
                              <option value="">-- Non importe --</option>
                              {courses.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="section">
                <div className="section-header"><h2>4. Apercu et import</h2></div>
                <div className="section-body">
                  <button className="btn success" onClick={genererApercu} style={{marginBottom:16}}>Generer l'apercu</button>
                  {apercu && (
                    <div>
                      <div className="apercu-stats">
                        <div className="apercu-stat cree"><strong>{apercu.aCreer.length}</strong><span>a creer</span></div>
                        <div className="apercu-stat maj"><strong>{apercu.aMettre.length}</strong><span>a mettre a jour</span></div>
                        <div className="apercu-stat ignore"><strong>{apercu.ignores.length}</strong><span>ignores</span></div>
                        {apercu.doublonsInterne.length > 0 && <div className="apercu-stat doublon"><strong>{apercu.doublonsInterne.length}</strong><span>doublons fichier</span></div>}
                        {(apercu.aAnnuler||[]).length > 0 && <div className="apercu-stat" style={{background:'#fdecea', border:'1px solid #e74c3c'}}><strong>{apercu.aAnnuler.length}</strong><span style={{color:'#c0392b'}}>annulations</span></div>}
                        {modeHelloAsso && repasNonRattachables.length > 0 && <div className="apercu-stat" style={{background:'#fff3cd', border:'1px solid #ffc107'}}><strong>{repasNonRattachables.length}</strong><span style={{color:'#856404'}}>proches (repas)</span></div>}
                      </div>
                      {apercu.doublonsInterne.length > 0 && (
                        <details open style={{marginBottom:12}}>
                          <summary style={{fontSize:13, color:'#c0392b', cursor:'pointer', fontWeight:600}}>
                            ⚠️ {apercu.doublonsInterne.length} doublon{apercu.doublonsInterne.length>1?'s':''} détecté{apercu.doublonsInterne.length>1?'s':''} dans le fichier — lignes ignorées
                          </summary>
                          <div style={{maxHeight:150, overflowY:'auto', marginTop:8}}>
                            {apercu.doublonsInterne.map((d, i) => (
                              <div key={i} style={{fontSize:12, padding:'4px 8px', background:'#fdecea', marginBottom:2, borderRadius:4, display:'flex', gap:12}}>
                                <strong>{d.nom} {d.prenom}</strong>
                                {d.dob && <span style={{color:'#888'}}>né(e) le {d.dob}</span>}
                                {d.courseNom && <span style={{color:'#888'}}>— {d.courseNom}</span>}
                              </div>
                            ))}
                          </div>
                        </details>
                      )}
                      {(apercu.aAnnuler||[]).length > 0 && (
                        <details open style={{marginBottom:12}}>
                          <summary style={{fontSize:13, color:'#c0392b', cursor:'pointer', fontWeight:600}}>
                            🚫 {apercu.aAnnuler.length} annulation{apercu.aAnnuler.length>1?'s':''} détectée{apercu.aAnnuler.length>1?'s':''} — paye passera à false
                          </summary>
                          <div style={{maxHeight:150, overflowY:'auto', marginTop:8}}>
                            {apercu.aAnnuler.map((r, i) => (
                              <div key={i} style={{fontSize:12, padding:'3px 8px', background:'#fdecea', marginBottom:2, borderRadius:4}}>
                                <strong>{r.nom} {r.prenom}</strong>{r.courseNom ? ' — ' + r.courseNom : ''}
                              </div>
                            ))}
                          </div>
                        </details>
                      )}
                      {modeHelloAsso && repasNonRattachables.length > 0 && (
                        <details style={{marginBottom:12}}>
                          <summary style={{fontSize:13, color:'#856404', cursor:'pointer', fontWeight:600}}>
                            🍽️ {repasNonRattachables.length} proche{repasNonRattachables.length>1?'s':''} non-inscrit{repasNonRattachables.length>1?'s':''} → importé{repasNonRattachables.length>1?'s':''} dans course Repas/Foodtruck
                          </summary>
                          <div style={{maxHeight:150, overflowY:'auto', marginTop:8}}>
                            {repasNonRattachables.map((r, i) => (
                              <div key={i} style={{fontSize:12, padding:'3px 8px', background:'#fff8e6', marginBottom:2, borderRadius:4}}>
                                <strong>{r.nom} {r.prenom}</strong> — {r.qte} repas{!courseRepasId ? <span style={{color:'#e74c3c', marginLeft:6}}>(course Repas/Foodtruck introuvable en base !)</span> : ''}
                              </div>
                            ))}
                          </div>
                        </details>
                      )}
                      {apercu.ignores.length > 0 && (
                        <details style={{marginBottom:12}}>
                          <summary style={{fontSize:13, color:'#888', cursor:'pointer'}}>Voir les lignes ignorees ({apercu.ignores.length})</summary>
                          <div style={{maxHeight:150, overflowY:'auto', marginTop:8}}>
                            {apercu.ignores.map((ig, i) => (
                              <div key={i} style={{fontSize:12, padding:'3px 8px', background:'#f9f9f9', marginBottom:2, borderRadius:4}}>
                                <strong>{ig.raison}</strong>
                                {ig.ligne && <span style={{color:'#aaa', marginLeft:8}}>{ig.ligne.slice(0,3).join(' | ')}</span>}
                              </div>
                            ))}
                          </div>
                        </details>
                      )}
                      {(apercu.aCreer.length > 0 || apercu.aMettre.length > 0) && (
                        <div style={{maxHeight:300, overflowY:'auto', border:'1px solid #eee', borderRadius:8, marginBottom:16}}>
                          <table className="table">
                            <thead><tr><th>Action</th><th>Nom</th><th>Prenom</th><th>Course</th><th>Genre</th><th>Type VTT</th><th>Email</th><th>Date cmd</th><th>Billet</th><th>Repas</th><th>Diffs</th></tr></thead>
                            <tbody>
                              {[...apercu.aCreer.map(c=>({...c,_action:'CREER'})),...apercu.aMettre.map(c=>({...c,_action:'MAJ'}))].slice(0,300).map((c,i) => (
                                <tr key={i} style={{background:c._action==='MAJ'?'#fff8e6':''}}>
                                  <td><span style={{color:c._action==='MAJ'?'#856404':'#1a7a5e',fontWeight:600,fontSize:12}}>{c._action}</span></td>
                                  <td>{c.nom}</td><td>{c.prenom}</td>
                                  <td>{courses.find(co=>co.id===c.course_id)?.nom||<span style={{color:'#e74c3c'}}>?</span>}</td>
                                  <td>{c.genre}</td><td>{c.type_vtt}</td>
                                  <td style={{fontSize:11}}>{c.email}</td>
                                  <td style={{fontSize:11, color: c.date_commande ? '#1a7a5e' : '#e74c3c'}}>{c.date_commande || '—'}</td>
                                  <td style={{fontSize:10, color: c.helloasso_num_billet ? '#555' : '#ddd'}}>{c.helloasso_num_billet || '—'}</td>
                                  <td style={{fontSize:12, fontWeight: c.nb_repas > 0 ? 700 : 400, color: c.nb_repas > 0 ? '#e67e22' : '#aaa'}}>{c.nb_repas > 0 ? c.nb_repas : '—'}</td>
                                  <td style={{fontSize:11,color:'#856404'}}>{c.diffs?.join(', ')}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <div style={{display:'flex', gap:10}}>
                        <button className="btn success" onClick={lancerImport} disabled={importing||(apercu.aCreer.length+apercu.aMettre.length===0)}>
                          {importing ? 'Import en cours...' : 'Lancer l\'import (' + (apercu.aCreer.length+apercu.aMettre.length) + ')'}
                        </button>
                        <button className="btn" style={{background:'#eee'}} onClick={() => setApercu(null)}>Annuler</button>
                      </div>
                    </div>
                  )}
                  {resultat && (
                    <div className="resultat-import">
                      <Check size={20} color="#1a7a5e"/>
                      <strong>Import termine !</strong>
                      <span>{resultat.crees} crees</span><span>{resultat.majRes} mis a jour</span>
                      {resultat.annules > 0 && <span style={{color:'#c0392b'}}>{resultat.annules} annules (paye=false)</span>}
                      <span>{resultat.ignores} ignores</span>
                      {resultat.erreurs > 0 && <span style={{color:'#c00'}}>{resultat.erreurs} erreurs</span>}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* ===================== IMPORT DOSSARDS ===================== */}
      {onglet === 'dossards' && (
        <div>
          <div className="section">
            <div className="section-body" style={{paddingTop:16}}>
              <input ref={fileDRef} type="file" accept=".xlsx,.xls,.csv" style={{display:'none'}} onChange={e => e.target.files[0] && onFichierDossards(e.target.files[0])} />
              <button className="btn success" onClick={() => fileDRef.current?.click()}>
                <Upload size={16}/> {fichierDossards ? fichierDossards.name : 'Choisir un fichier CSV/Excel'}
              </button>
              {fichierDossards && <span style={{marginLeft:10, fontSize:13, color:'#888'}}>{lignesDossards.length} lignes detectees</span>}
            </div>
          </div>
          {colonnesDossards.length > 0 && (
            <>
              <div className="section">
                <div className="section-header"><h2>Mapping colonnes</h2></div>
                <div className="section-body">
                  <div className="mapping-grid">
                    <div className="mapping-row">
                      <label className="mapping-label">Colonne Dossard *</label>
                      <select value={colonneDossard} onChange={e => setColonneDossard(e.target.value)}>
                        <option value="">--</option>
                        {colonnesDossards.map(c => <option key={c.index} value={String(c.index)}>{c.label}</option>)}
                      </select>
                    </div>
                    <div className="mapping-row">
                      <label className="mapping-label">Colonne Course</label>
                      <select value={colonneCourse} onChange={e => setColonneCourse(e.target.value)}>
                        <option value="">-- Pas de colonne course --</option>
                        {colonnesDossards.map(c => <option key={c.index} value={String(c.index)}>{c.label}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {colonneCourse && equivalencesCourseD.length > 0 && (
                <div className="section">
                  <div className="section-header"><h2>Equivalences courses</h2></div>
                  <div className="section-body">
                    <table className="table">
                      <thead><tr><th>Valeur fichier</th><th>Course application</th></tr></thead>
                      <tbody>
                        {equivalencesCourseD.map((eq, i) => (
                          <tr key={i}>
                            <td><strong>{eq.source}</strong></td>
                            <td>
                              <select value={eq.cible} onChange={e => { const copy=[...equivalencesCourseD]; copy[i]={...copy[i],cible:e.target.value}; setEquivalencesCourseD(copy) }}>
                                <option value="">--</option>
                                {courses.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                              </select>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="section">
                <div className="section-body" style={{paddingTop:16}}>
                  <button className="btn success" onClick={genererApercuDossards} style={{marginBottom:16}}>Generer l'apercu</button>
                  {apercuDossards && (
                    <div>
                      <div className="apercu-stats">
                        <div className="apercu-stat cree"><strong>{apercuDossards.aAjouter.length}</strong><span>a ajouter</span></div>
                        <div className="apercu-stat ignore"><strong>{apercuDossards.dejaPresents.length}</strong><span>deja presents</span></div>
                        {apercuDossards.sansCorrespondance.length > 0 && <div className="apercu-stat doublon"><strong>{apercuDossards.sansCorrespondance.length}</strong><span>sans course</span></div>}
                      </div>
                      <div style={{maxHeight:250, overflowY:'auto', border:'1px solid #eee', borderRadius:8, marginBottom:16}}>
                        <table className="table">
                          <thead><tr><th>Dossard</th><th>Course</th><th>Statut</th></tr></thead>
                          <tbody>
                            {apercuDossards.aAjouter.slice(0,300).map((d,i) => (
                              <tr key={i}><td><strong>{d.dossard}</strong></td><td>{courses.find(c=>c.id===d.course_id)?.nom||'--'}</td><td><span style={{color:'#1a7a5e',fontSize:12,fontWeight:600}}>NOUVEAU</span></td></tr>
                            ))}
                            {apercuDossards.dejaPresents.slice(0,20).map((d,i) => (
                              <tr key={'dp'+i} style={{opacity:0.5}}><td><strong>{d.dossard}</strong></td><td>--</td><td><span style={{fontSize:12}}>{d.attribue?'Deja attribue':'Deja present'}</span></td></tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div style={{display:'flex', gap:10}}>
                        <button className="btn success" onClick={lancerImportDossards} disabled={importingDossards}>
                          {importingDossards ? 'Import + synchronisation...' : 'Importer ' + apercuDossards.aAjouter.length + ' dossards'}
                        </button>
                        <button className="btn" style={{background:'#eee'}} onClick={() => setApercuDossards(null)}>Annuler</button>
                      </div>
                      <p style={{fontSize:12, color:'#888', marginTop:8}}>
                        La synchronisation avec les coureurs existants sera lancee automatiquement apres l'import.
                      </p>
                    </div>
                  )}
                  {resultatDossards && (
                    <div className="resultat-import">
                      <Check size={20} color="#1a7a5e"/>
                      <strong>Import termine !</strong>
                      <span>{resultatDossards.ajoutes} dossards ajoutes</span>
                      <span>{resultatDossards.dejaPresents} deja presents</span>
                      {resultatDossards.erreurs > 0 && <span style={{color:'#c00'}}>{resultatDossards.erreurs} erreurs</span>}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* ===================== GESTION DOSSARDS ===================== */}
      {onglet === 'gestion' && (
        <div>
          <div className="stats-kpis" style={{marginBottom:16}}>
            <div className="stat-card primary"><div className="stat-value">{dossardsDB.length}</div><div className="stat-label">Total dossards</div></div>
            <div className="stat-card success"><div className="stat-value">{nbAttribues}</div><div className="stat-label">Attribues</div></div>
            <div className="stat-card"><div className="stat-value">{nbLibres}</div><div className="stat-label">Libres</div></div>
            <div className="stat-card"><div className="stat-value">{coureurs.filter(c=>!c.dossard).length}</div><div className="stat-label">Coureurs sans dossard</div></div>
          </div>

          <div className="section">
            <div className="section-header"><h2>Actions</h2></div>
            <div className="section-body" style={{display:'flex', gap:10, flexWrap:'wrap'}}>
              <button className="btn" style={{background:'#f0f0f0', display:'flex', alignItems:'center', gap:6}} onClick={lancerControle}
                title="Vérifie la cohérence entre coureurs et dossards : liste les coureurs sans dossard, les dossards hors liste, et les désynchronisations. Ne modifie rien.">
                <RefreshCw size={14}/> Controle de coherence
              </button>
              <button className="btn" style={{background:'#f0f0f0', display:'flex', alignItems:'center', gap:6}} onClick={() => syncDossardsCoureurs(false)} disabled={loadingSync}
                title="Réconcilie dossards_disponibles avec les coureurs : marque 'attribué' les dossards déjà portés, libère ceux dont le lien est rompu.">
                <RefreshCw size={14}/> {loadingSync ? 'Synchronisation...' : 'Synchroniser dossards'}
              </button>
              <button className="btn success" style={{display:'flex', alignItems:'center', gap:6}} onClick={attribuerDossardsAuto} disabled={loadingAttrib}
                title="Attribue automatiquement un dossard libre à chaque coureur qui n'en a pas, par ordre numérique croissant, en respectant la course de chaque coureur.">
                <Zap size={14}/> {loadingAttrib ? 'Attribution...' : 'Attribuer dossards manquants (auto)'}
              </button>
              <button className="btn" style={{background:'#eee', display:'flex', alignItems:'center', gap:6}} onClick={fetchDossardsEtCoureurs}
                title="Recharge les données depuis la base de données sans effectuer aucune modification.">
                <RefreshCw size={14}/> Rafraichir
              </button>
            </div>
          </div>

          {syncResultat && (
            <div className="resultat-import" style={{marginBottom:16}}>
              <Check size={20} color="#1a7a5e"/>
              <strong>Synchronisation terminee !</strong>
              <span>{syncResultat.syncs} dossard(s) synchronise(s)</span>
              <span>{syncResultat.liberations} dossard(s) libere(s)</span>
            </div>
          )}

          {controleResultat && (
            <div className="section">
              <div className="section-header"><h2>Resultats du controle</h2></div>
              <div className="section-body">
                {controleResultat.sansDossard.length === 0 && controleResultat.horsListe.length === 0 && controleResultat.desynchro.length === 0 ? (
                  <div className="resultat-import"><Check size={20} color="#1a7a5e"/><strong>Tout est coherent !</strong></div>
                ) : (
                  <div style={{display:'flex', flexDirection:'column', gap:12}}>
                    {controleResultat.sansDossard.length > 0 && (
                      <div>
                        <div style={{fontWeight:600, color:'#856404', marginBottom:6}}>{controleResultat.sansDossard.length} coureur(s) sans dossard</div>
                        <div style={{maxHeight:150, overflowY:'auto'}}>
                          {controleResultat.sansDossard.map(c => (
                            <div key={c.id} style={{fontSize:13, padding:'3px 8px', background:'#fff8e6', borderRadius:4, marginBottom:2}}>
                              {c.nom} {c.prenom} — {c.courses?.nom}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {controleResultat.horsListe.length > 0 && (
                      <div>
                        <div style={{fontWeight:600, color:'#e74c3c', marginBottom:6}}>{controleResultat.horsListe.length} coureur(s) avec dossard hors liste</div>
                        <div style={{maxHeight:150, overflowY:'auto'}}>
                          {controleResultat.horsListe.map(c => (
                            <div key={c.id} style={{fontSize:13, padding:'3px 8px', background:'#fee', borderRadius:4, marginBottom:2}}>
                              {c.nom} {c.prenom} — dossard <strong>{c.dossard}</strong> introuvable dans la liste
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {controleResultat.desynchro.length > 0 && (
                      <div>
                        <div style={{fontWeight:600, color:'#856404', marginBottom:6}}>{controleResultat.desynchro.length} dossard(s) desynchronise(s)</div>
                        <div style={{maxHeight:150, overflowY:'auto'}}>
                          {controleResultat.desynchro.map(d => (
                            <div key={d.id} style={{fontSize:13, padding:'3px 8px', background:'#fff8e6', borderRadius:4, marginBottom:2}}>
                              Dossard <strong>{d.dossard}</strong> marque attribue mais coureur non trouve
                            </div>
                          ))}
                        </div>
                        <button className="btn" style={{background:'#f0f0f0', marginTop:8, fontSize:13}} onClick={() => syncDossardsCoureurs(false)}>
                          Corriger automatiquement
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {attributionResultat && (
            <div className="resultat-import">
              <Check size={20} color="#1a7a5e"/>
              <strong>Attribution terminee !</strong>
              <span>{attributionResultat.attribues} dossards attribues</span>
              {attributionResultat.sansDisponible > 0 && <span style={{color:'#856404'}}>{attributionResultat.sansDisponible} coureur(s) sans dossard disponible</span>}
            </div>
          )}

          <div className="section">
            <div className="section-header"><h2>Liste des dossards ({dossardsFiltres.length})</h2></div>
            <div className="section-body">

              {/* Ajout manuel */}
              <div style={{display:'flex', gap:8, marginBottom:12, flexWrap:'wrap', alignItems:'center', padding:'10px 12px', background:'#f8f8f8', borderRadius:8, border:'1px solid #eee'}}>
                <span style={{fontSize:13, fontWeight:600, color:'#444'}}>Ajouter un dossard :</span>
                <input
                  type="text" placeholder="Code dossard" value={ajoutManuel.dossard}
                  onChange={e => { setAjoutManuel(a => ({...a, dossard: e.target.value})); setAjoutManuelError('') }}
                  style={{width:110, fontSize:13, padding:'4px 8px'}}
                />
                <select value={ajoutManuel.course_id} onChange={e => setAjoutManuel(a => ({...a, course_id: e.target.value}))} style={{fontSize:13, padding:'4px 8px'}}>
                  <option value="">Course (optionnel)</option>
                  {courses.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                </select>
                <button className="btn success" style={{fontSize:13, padding:'4px 12px'}} onClick={ajouterDossardManuel}>+ Ajouter</button>
                {ajoutManuelError && <span style={{color:'#c0392b', fontSize:12}}>{ajoutManuelError}</span>}
              </div>

              {/* Filtres */}
              <div style={{display:'flex', gap:10, marginBottom:12, flexWrap:'wrap', alignItems:'center'}}>
                <select className="course-filter-select" value={filterCourseD} onChange={e => setFilterCourseD(e.target.value)}>
                  <option value="">Toutes les courses</option>
                  {courses.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                </select>
                <select className="course-filter-select" value={filterStatutD} onChange={e => setFilterStatutD(e.target.value)}>
                  <option value="">Tous les statuts</option>
                  <option value="libre">Libres uniquement</option>
                  <option value="attribue">Attribues uniquement</option>
                </select>
                <button className="btn" style={{marginLeft:'auto', fontSize:12, padding:'4px 10px', background:'#fdecea', color:'#c0392b', border:'1px solid #e74c3c'}}
                  onClick={() => setConfirmVider(true)} title="Supprime toute la liste et retire les attributions de tous les coureurs">
                  🗑 Vider les dossards
                </button>
              </div>

              {/* Modal confirmation vider */}
              {confirmVider && (
                <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <div style={{background:'#fff', borderRadius:12, padding:28, maxWidth:420, width:'90%', boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}>
                    <h3 style={{color:'#c0392b', marginBottom:12}}>⚠️ Vider tous les dossards ?</h3>
                    <p style={{fontSize:14, marginBottom:16, color:'#555'}}>
                      Cette action va <strong>supprimer toute la liste des dossards</strong> et retirer les attributions de tous les coureurs. Les détections et pointages ne sont pas affectés.
                    </p>
                    <div style={{display:'flex', gap:10}}>
                      <button className="btn" style={{background:'#c0392b', color:'#fff', flex:1}} onClick={viderDossards} disabled={loadingVider}>
                        {loadingVider ? 'Suppression...' : 'Confirmer'}
                      </button>
                      <button className="btn" style={{background:'#eee', flex:1}} onClick={() => setConfirmVider(false)} disabled={loadingVider}>Annuler</button>
                    </div>
                  </div>
                </div>
              )}
              {loadingDossards ? <div className="loading">Chargement...</div> : (
                <div style={{maxHeight:500, overflowY:'auto', border:'1px solid #eee', borderRadius:8}}>
                  <table className="table">
                    <thead><tr><th>Dossard</th><th>Course</th><th>Statut</th><th>Coureur associe</th></tr></thead>
                    <tbody>
                      {dossardsFiltres.map(d => {
                        const coureur = coureurs.find(c => c.id === d.coureur_id)
                        const isEditing = editDossardId === d.id
                        return (
                          <tr key={d.id}>
                            <td><strong>{d.dossard}</strong></td>
                            <td>
                              {!d.attribue && isEditing ? (
                                <div style={{display:'flex', gap:6, alignItems:'center'}}>
                                  <select defaultValue={d.course_id} onChange={e => setEditDossardCourse(e.target.value)} style={{fontSize:12, padding:'2px 4px'}}>
                                    <option value="">--</option>
                                    {courses.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                                  </select>
                                  <button className="btn" style={{fontSize:11, padding:'2px 8px', background:'#1a7a5e', color:'#fff'}} onClick={() => changerCourseDossard(d, editDossardCourse || d.course_id)}>✓</button>
                                  <button className="btn" style={{fontSize:11, padding:'2px 8px', background:'#eee'}} onClick={() => setEditDossardId(null)}>✗</button>
                                </div>
                              ) : (
                                <span
                                  style={!d.attribue ? {cursor:'pointer', borderBottom:'1px dashed #aaa'} : {}}
                                  title={!d.attribue ? 'Cliquer pour changer de course' : ''}
                                  onClick={() => { if (!d.attribue) { setEditDossardId(d.id); setEditDossardCourse(d.course_id) } }}
                                >
                                  {d.courses?.nom || '--'}
                                </span>
                              )}
                            </td>
                            <td>{d.attribue ? <span style={{color:'#1a7a5e',fontWeight:600,fontSize:12}}>Attribue</span> : <span style={{color:'#aaa',fontSize:12}}>Libre</span>}</td>
                            <td style={{fontSize:13}}>{coureur ? coureur.nom + ' ' + coureur.prenom : '--'}</td>
                          </tr>
                        )
                      })}
                      {dossardsFiltres.length === 0 && <tr><td colSpan={4} style={{textAlign:'center',color:'#aaa',padding:20}}>Aucun dossard</td></tr>}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
